import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import BusyButton from '../form/BusyButton';

/**
 * Confirmation prompt for destructive actions. `onConfirm` may return a
 * promise; the dialog shows a busy state and closes itself when it resolves.
 */
const ConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  danger = true,
  onConfirm,
  onClose,
}) => {
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    setBusy(true);
    try {
      await onConfirm();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={busy}>
          {cancelLabel}
        </Button>
        <BusyButton onClick={handleConfirm} variant="contained" color={danger ? 'error' : 'primary'} busy={busy} autoFocus>
          {confirmLabel}
        </BusyButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
